document.addEventListener('DOMContentLoaded', function () {
  const calculateButton = document.getElementById('calculate-bioload');
  const volumeToggle = document.getElementById('volume-unit-toggle');
  const volumeLabel = document.getElementById('volume-unit-label');
  const unitLabels = document.querySelectorAll('.unit-toggle span');

  if (!calculateButton) return;

  let usingLiters = false;

  if (volumeToggle) {
    volumeToggle.addEventListener('change', function () {
      usingLiters = this.checked;

      unitLabels.forEach(function (label) {
        label.classList.remove('active');
      });

      if (usingLiters) {
        document.querySelector('[data-unit="liters"]').classList.add('active');
        volumeLabel.textContent = 'Liters';
      } else {
        document.querySelector('[data-unit="gallons"]').classList.add('active');
        volumeLabel.textContent = 'Gallons';
      }
    });
  }

  calculateButton.addEventListener('click', function () {
    const tankInput = parseFloat(document.getElementById('tank-size').value) || 0;

    let tankSizeGallons = tankInput;

    if (usingLiters) {
      tankSizeGallons = tankInput * 0.264172;
    }

    const xsFish = parseInt(document.getElementById('xs-fish').value) || 0;
    const smallFish = parseInt(document.getElementById('small-fish').value) || 0;
    const mediumFish = parseInt(document.getElementById('medium-fish').value) || 0;
    const largeFish = parseInt(document.getElementById('large-fish').value) || 0;
    const xlFish = parseInt(document.getElementById('xl-fish').value) || 0;

    const filtrationSelect = document.getElementById('filtration-level');
    const filtrationModifier = parseFloat(filtrationSelect.value) || 1;

    const totalPoints =
        xsFish * 1 +
        smallFish * 2 +
        mediumFish * 4 +
        largeFish * 8 +
        xlFish * 12;

    const effectiveCapacity = tankSizeGallons * filtrationModifier;
    const bioloadRatio = tankSizeGallons > 0 ? totalPoints / effectiveCapacity : 0;

    let rating = 'Enter Tank Size';
    let message = 'Please enter your total system volume to calculate estimated bioload.';
    let className = 'neutral';

    if (tankSizeGallons > 0) {
      if (bioloadRatio <= 0.15) {
        rating = 'Low Bioload';
        message = 'Your aquarium appears lightly stocked. This usually gives you more flexibility and a wider margin for water quality stability.';
        className = 'low';
      } else if (bioloadRatio <= 0.30) {
        rating = 'Medium Bioload';
        message = 'Your stocking level looks reasonable for many established aquariums with proper filtration and regular maintenance.';
        className = 'medium';
      } else if (bioloadRatio <= 0.45) {
        rating = 'High Bioload';
        message = 'Your aquarium is carrying a heavier fish load. Strong filtration, consistent water changes, and careful feeding are important.';
        className = 'high';
      } else {
        rating = 'Overstocked';
        message = 'This tank may be overstocked based on fish count, fish size, and filtration level. Consider reducing stocking or increasing filtration capacity.';
        className = 'overstocked';
      }
    }

    const markerPercent = Math.min((bioloadRatio / 0.6) * 100, 100);

    document.getElementById('result-title').textContent = rating;
    document.getElementById('result-message').textContent = message;
    document.getElementById('rating-box').className = 'rating-box ' + className;

    document.getElementById('total-points').textContent = totalPoints;

    if (usingLiters) {
      document.getElementById('summary-tank-size').textContent = tankInput.toFixed(0) + ' L';
      document.getElementById('summary-converted-size').textContent = tankSizeGallons.toFixed(1) + ' gal';
    } else {
      document.getElementById('summary-tank-size').textContent = tankInput.toFixed(0) + ' gal';
      document.getElementById('summary-converted-size').textContent = tankSizeGallons.toFixed(1) + ' gal';
    }

    document.getElementById('summary-filtration').textContent = filtrationModifier.toFixed(2) + 'x';
    document.getElementById('effective-capacity').textContent = effectiveCapacity.toFixed(1) + ' gal';
    document.getElementById('bioload-ratio').textContent = bioloadRatio.toFixed(2);
    document.getElementById('bioload-ratio-large').textContent = bioloadRatio.toFixed(2);
    document.getElementById('gauge-marker').style.left = markerPercent + '%';
  });
});